export default from './scrape';



/** WEBPACK FOOTER **
 ** ./src/scraper/index.js
 **/